import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_GOAL} from '../../metamodel/Concept';

export default class GoalNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_GOAL;
	}
}
